<label class="checkbox-label">
    <input (blur)="onCheckboxBlur()"
           (change)="onCheckboxChange($event)"
           [attr.aria-label]="labelText()"
           [attr.data-qa]="qaTag()"
           [checked]="isChecked() || isCheckedByForm || null"
           [disabled]="isDisabled() || isDisabledByForm || null"
           [id]="id()"
           class="checkbox-input"
           type="checkbox"/>
    <app-icon [class.checked]="isChecked() || isCheckedByForm" [svgIcon]="ICONS.SEND_TICK" aria-hidden="true" class="checkbox-icon"/>
    <ng-content>{{ labelText() }}</ng-content>
</label>
